import { useQuery } from "@tanstack/react-query";
import api from "@/services/api";
import { queryKeys } from "@/queryKeys";

export interface UnicourtCasesResult {
  cases: import("../../components/defaultHistory/DefaultHistory").UniCourtCase[];
  awaitingDocuments: boolean;
  awaitingDocumentsCount: number;
}

export function useUnicourtCasesQuery(borrowerId: string | null, enabled = true) {
  const id = borrowerId ?? null;
  return useQuery({
    queryKey: queryKeys.unicourtCases(id),
    queryFn: async (): Promise<UnicourtCasesResult> => {
      const response = await api.get<{
        cases?: UnicourtCasesResult["cases"];
        awaiting_documents?: boolean;
        awaiting_documents_count?: number;
      }>(`/borrowers/${id}/unicourt-cases/`);
      return {
        cases: response.data.cases ?? [],
        awaitingDocuments: response.data.awaiting_documents ?? false,
        awaitingDocumentsCount: response.data.awaiting_documents_count ?? 0,
      };
    },
    enabled: !!id && enabled,
  });
}
